import { render, staticRenderFns } from "./CustomerNominationStats.vue?vue&type=template&id=0ee3d3eb&scoped=true&"
import script from "./CustomerNominationStats.vue?vue&type=script&lang=js&"
export * from "./CustomerNominationStats.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNominationStats.vue?vue&type=style&index=0&id=0ee3d3eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee3d3eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable,VSkeletonLoader})
